import * as React from 'react';
import { RootStore, withInjectedRootStore } from 'providers';
import { observer } from 'mobx-react';
import { DataHooks } from 'enums';

export interface ScrollRefProps {
  rootStore: RootStore;
}

const ScrollRefComponent: React.FC<ScrollRefProps> = ({ rootStore }) => {
  const { setScrollToTopRef } = rootStore.appStore;

  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setScrollToTopRef(ref.current);
  }, [setScrollToTopRef]);

  return <span ref={ref} data-hook={DataHooks.ScrollRef} />;
};

export const ScrollRef = withInjectedRootStore(observer(ScrollRefComponent));
